<!-- NAVBAR -->
<!--<nav class="bg-gray-800 text-white px-6 py-3 flex justify-between items-center shadow">
  <div class="text-xl font-bold">
    <a routerLink="/">Wearistyle</a>
  </div>

  <div class="flex gap-4 items-center">
    <a routerLink="/" class="hover:text-blue-300">Home</a>

    <a *ngIf="!auth.isLoggedIn()" routerLink="/login" class="hover:text-blue-300">Login</a>
    <a *ngIf="!auth.isLoggedIn()" routerLink="/register" class="hover:text-blue-300">Register</a>
    <a *ngIf="auth.isLoggedIn()" routerLink="/profile" class="hover:text-green-400">Profile</a>
    dashboard
    <a *ngIf="auth.isLoggedIn()" routerLink="/profile" class="hover:text-green-400">Profile</a>-->

    <!-- Show only for admin -->
    <!--<a *ngIf="auth.getUserRole() === 'Admin'" routerLink="/admin/products">Manage Products</a>

    <a routerLink="admin/products" class="hover:underline">Product List</a>
    <a routerLink="admin/CreateProduct" class="hover:underline">Add Product</a>

    <a routerLink="admin/categories" class="hover:underline">Categories</a>
    <a routerLink="admin/categories/create" class="hover:underline">Add Category</a>

    <a routerLink="/cart" class="relative inline-block">
      🛒
      <span *ngIf="cartItemCount > 0" class="absolute -top-2 -right-2 bg-blue-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
        {{ cartItemCount }}
      </span>
    </a>-->

    <!-- Show only for users -->
    <!--<a *ngIf="auth.getUserRole() === 'User'" routerLink="/shop">Shop Now</a>

    <button *ngIf="auth.isLoggedIn()" (click)="logout()" class="text-red-400 hover:text-red-600">Logout</button>
  </div>
</nav>-->

<nav class="bg-gray-800 text-white px-6 py-3 flex items-center justify-between">
  <div class="text-xl font-bold">
    <a routerLink="/">Wearistyle</a>
  </div>
  <div class="flex gap-4 items-center">
    <a routerLink="/" class="hover:text-blue-300">Home</a>
    <a *ngIf="!auth.isLoggedIn()" routerLink="/login" class="hover:text-blue-300">Login</a>
    <a *ngIf="!auth.isLoggedIn()" routerLink="/register" class="hover:text-blue-300">User Register</a>
    <a *ngIf="!auth.isLoggedIn()" routerLink="/admin/vendor-register" class="hover:text-blue-300">Vendor Register</a>

    <!--<a *ngIf="auth.isLoggedIn()" routerLink="/shop" class="hover:text-blue-300">Shop Now</a>-->
    <!--<a *ngIf="auth.isLoggedIn()" routerLink="/dashboard/profile" class="hover:text-green-400">Profile</a>-->

  </div>

  <div class="flex space-x-6">
    <ng-container *ngFor="let item of menuItems">
      <!-- Parent menu -->
      <div class="relative group">
        <a [routerLink]="item.route"
           class="px-3 py-2 rounded-md hover:bg-gray-700"
           routerLinkActive="bg-gray-700">
          {{ item.label }}
        </a>

        <!-- Dropdown children -->
        <div *ngIf="item.children"
             class="absolute hidden group-hover:block bg-gray-700 rounded-md mt-2 w-48">
          <a *ngFor="let child of item.children"
             [routerLink]="child.route"
             routerLinkActive="bg-gray-600"
             class="block px-4 py-2 hover:bg-gray-600">
            {{ child.label }}
          </a>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="flex gap-4 items-center">
    <a routerLink="/cart" class="relative inline-block">
      🛒
      <span *ngIf="cartItemCount > 0" class="absolute -top-2 -right-2 bg-blue-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
        {{ cartItemCount }}
      </span>
    </a>
    <button *ngIf="auth.isLoggedIn()" (click)="logout()" class="text-red-400 hover:text-red-600">Logout</button>
  </div>
</nav>
